import { render, staticRenderFns } from "./sendScreening.vue?vue&type=template&id=35f37a75&scoped=true&"
import script from "./sendScreening.vue?vue&type=script&lang=js&"
export * from "./sendScreening.vue?vue&type=script&lang=js&"
import style0 from "./sendScreening.vue?vue&type=style&index=0&id=35f37a75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f37a75",
  null
  
)

export default component.exports